import React, { Component } from "react";
import { Helmet } from "react-helmet";
import logo from "../../assets/logo.png";
import Navbar from "../Navbar/Navbar";
import TermsContent from "./TermsContent";
import BottomBar from "../BottomBar/BottomBar";
class Terms extends Component {
  render() {
    return (
   
        <div id='terms' className="main">
          <Helmet>
            <title>Terms &amp; Conditions | MoneyMonk</title>
            <meta name="description" content="Read the terms and conditions for using MoneyMonk's digital lending platform, operated by Monk Capital Private Limited, an RBI Registered NBFC." />
            <link rel="canonical" href="https://moneymonkapp.in/termsandconditions" />
          </Helmet>
          <Navbar imageData={logo} />
          <TermsContent />
          <BottomBar />
        </div>

    );
  }
}

export default Terms;
